import { commonConstants } from '@config/constants/common';
import { Constants } from '@config/constants/constants.interface';

export const constantsPattern: Constants = {
  ...commonConstants,

  /* Legacy Auth/MCS Endpoints */
  // baseUrl: 'https://exeloneumobileapptest-a453576.mobileenv.us2.oraclecloud.com/mobile/custom/anon_v5/peco/',
  baseUrl: '../.mcs/mobile/custom/',
  token: '',
  opco: 'bge',
  mcsMobileBackendId: 'e29bdb09-b255-4323-b6e0-0b494a6ddf37',
  mcsAnonymousKey: 'YW5vbl90c3Q6NkclUXViQGxaQm1vZ09xJFc4Qlg=',
  sessionAccountNumber: '',
  sessionCustomerName: '',
  sessionUsernameKey: '',
  sessionClientId: ''
};
